export const PermissionCustomer = {
    PUT: "mgr-customers-**-PUT",
    // TODO: adicionar key de authority de cadastrar cliente
    POST: "mgr-customers-**-PUT",
    DELETE: "mgr-customers-**-DELETE",
    GET: "mgr-customers-search-GET",
    GET_UUID: "mgr-customers-**-GET"
};